import { BuyTogether } from '@digital-retail/buy-together';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withBuyTogether } from '../../../utils/BuyTogetherContext';
import { withCart } from '../../../utils/CartContext';
import { isWindow } from '../../../utils/deviceChecker';
import { withProduct } from '../../../utils/ProductContext';
import useIntersection from '../../../utils/useIntersection';
import WebStorage from '../../../utils/WebStorage';
import { BuyTogetherStyle } from './BuyTogether.style';
import { buyTogetherLabels } from './constants';
import { useBuyTogetherHandler } from './useBuyTogetherHandler';
import { mapMainVariant } from './utils';

const BUY_TOGETHER_RECURRENT_CUSTOMER = 'isBuyTogetherRecurrentCustomer';

const BuyTogetherContainer = ({ product, buytogether, appCtx, cart, classes }) => {
  const buyTogetherRef = useRef(null);
  const isBuyTogetherInViewport = useIntersection(buyTogetherRef, '0px', 0.5, false);

  const { handleAddToCart, updateAnalyticsClick, getImpressionAnalytics, fireImpressionEventOnViewport } =
    useBuyTogetherHandler({ product, buytogether, appCtx, cart });

  useEffect(() => {
    if (isWindow() && isBuyTogetherInViewport) {
      fireImpressionEventOnViewport();
    }
  }, [isBuyTogetherInViewport]);
  const mainVariant = React.useMemo(() => mapMainVariant({ product }), [product]);

  if (!buytogether?.data?.length || product.isOutOfStock) return null;

  const isRecurrentCustomer = WebStorage.getItem({
    name: BUY_TOGETHER_RECURRENT_CUSTOMER,
    fromPersistence: true,
  });

  if (isRecurrentCustomer !== true) {
    WebStorage.setItem({
      name: BUY_TOGETHER_RECURRENT_CUSTOMER,
      shouldPersist: true,
      value: true,
    });
  }

  return (
    <div id="testId-pdp-slot3">
      <hr className="divider-line" />
      <div className={`${classes} buy-together-wrapper`} ref={buyTogetherRef} data-widget-name={buytogether.widgetName}>
        <BuyTogether
          mainVariant={mainVariant}
          relatedVariants={buytogether.data}
          labels={{
            ...buyTogetherLabels,
            title: buytogether.widgetName,
          }}
          podWidthPx={216}
          onVariantSelection={buytogether.onVariantSelection}
          config={{ minVariants: 3 }}
          isMobile={appCtx.deviceType === 'mobile'}
          isAllSelected={buytogether.isAllSelected}
          onSelectedAll={buytogether.handleSelectAll}
          onQtyChange={buytogether.handleQtyChange}
          onAddToCart={handleAddToCart}
          getCanonicalUrl={buytogether.getCanonicalUrl}
          toastStyles={{ zIndex: 10 }}
          updateAnalyticsClick={updateAnalyticsClick}
          getImpressionAnalytics={getImpressionAnalytics}
          defaultActiveTooltip={!isRecurrentCustomer}
        />
      </div>
      <style jsx>{BuyTogetherStyle}</style>
    </div>
  );
};

BuyTogetherContainer.defaultProps = {
  classes: '',
};

BuyTogetherContainer.propTypes = {
  product: PropTypes.object.isRequired,
  buytogether: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  classes: PropTypes.string,
};

export { BuyTogetherContainer };
export default withCart(withProduct(withApplicationContext(withBuyTogether(BuyTogetherContainer))));
